module.exports = __webpack_public_path__ + "static/media/essentials.37e22b17.svg";